import { render, staticRenderFns } from "./JurisdictionalCar.vue?vue&type=template&id=a67d6a70&scoped=true&"
import script from "./JurisdictionalCar.vue?vue&type=script&lang=js&"
export * from "./JurisdictionalCar.vue?vue&type=script&lang=js&"
import style0 from "./JurisdictionalCar.vue?vue&type=style&index=0&id=a67d6a70&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67d6a70",
  null
  
)

export default component.exports